/** How many messages the open chat keeps. Older ones scroll off; the last topic stays in memory beside the log. */
export const CHAT_MESSAGE_CAP = 40;

export function capChatMessages<T>(messages: T[]): T[] {
  return messages.length > CHAT_MESSAGE_CAP ? messages.slice(messages.length - CHAT_MESSAGE_CAP) : messages;
}
